import React from "react";
import { Link } from "react-router-dom";
import { Button, DropdownButton } from "../Button";
import { Input, Select } from "../Input";
import { Pagination } from "../Pagination";
import "./styles.css";
import { Loading } from "../Loader";
import { CSVLink } from "react-csv";
import {
  CentersFilter,
  DateFilter,
  DepartmentFilter,
  HospitalsFilter,
  BloodGroupFilter,
  DonorCategoryFilter,
  CenterSitesFilter,
} from "../Filters";
import TableData from "./TableData";
import InstitutionFilter from "../Filters/InstitutionFilter";
import HospitalFilter from "../Filters/HospitalFilter";

let copyData = [];
class Table extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      page: props.page ? props.page : 1,
      limit: props.limit,
      search_text: "",
      data: props.data,
    };

    this._searchTimer = null;
  }

  componentDidMount(props) {
    copyData = this.props.data;
  }

  componentDidUpdate(nextProps, nextState) {
    if (nextState.data !== this.props.data) {
      this.setState({
        data: this.props.data,
      });
    }
  }

  handleSearch(e) {
    let new_data = [],
      search_text = e?.target?.value;

    for (let i = 0; i < copyData.length; i++) {
      if (
        JSON.stringify(copyData[i])
          .toUpperCase()
          .indexOf(search_text.toUpperCase()) !== -1
      ) {
        new_data.push(copyData[i]);
      }
    }

    this.setState({
      data: new_data,
      search_text,
    });
  }

  renderInput = ({
    placeholder,
    leftIcon,
    fieldName,
    onChange,
    iconRight,
    type,
    onKeyDown,
  }) => {
    return (
      <Input
        placeholder={placeholder}
        leftIcon={leftIcon}
        value={this.props[fieldName] ?? ""}
        onChange={onChange}
        onKeyDown={onKeyDown}
        iconRight={iconRight}
        inputContainerStyle={{
          marginBottom: 0,
        }}
        autoComplete="off"
        type={type}
        className="sm w-sm-100"
      />
    );
  };

  renderSelection = ({
    placeholder,
    leftIcon,
    fieldName,
    onChange,
    iconRight,
    type,
    options,
  }) => {
    return (
      <Select
        options={options}
        placeholder={placeholder}
        leftIcon={leftIcon}
        value={this.props[fieldName] ?? ""}
        onChange={(e) => onChange(e?.target ? e.target.value : e)}
        iconRight={iconRight}
        inputContainerStyle={{
          marginBottom: 0,
        }}
        type={type}
        className="sm w-sm-100"
      />
    );
  };

  renderButton = ({ text, onPress, className }) => {
    return (
      <Button
        text={text}
        onPress={onPress}
        className={`${className} sm w-sm-100`}
      />
    );
  };

  render() {
    const {
      handlePagination,
      headers,
      totalPageCount,
      totalRecords,
      actions,
      rowPress,
      bordered,
      filters,
      showAdd,
      addButtonText,
      handleAddPressed,
      isLoading,
      page,
      placeholder,
      handleSort,
      sortOrder,
      sortColumn,
      tab,
      collapsing,
    } = this.props;

    const { limit, data } = this.state;

    const currentData = data && data.data ? data.data : data; // temporary fix
    const firstPage = 1;
    const lastPage = totalPageCount;

    const paginate = async (numPage) => {
      await handlePagination(numPage, tab);
    };

    const nextPage = async () => {
      if (page === lastPage) return;
      await handlePagination(page + 1, tab);
    };

    const prevPage = async () => {
      if (page === firstPage) return;
      await handlePagination(page - 1, tab);
    };

    const handleLimitChange = (newLimit) => {
      this.setState({ limit: newLimit });
      if (this.props.onLimitChange) {
        this.props.onLimitChange(newLimit);
      } else {
        handlePagination(1, tab, newLimit);
      }
    };

    return (
      <div>
        <div>
          <div className="table-header-container">
            <div className="table-search-container">
              {this.props.titleContent && <div>{this.props.titleContent}</div>}
              {this.props.isSearch &&
                this.renderInput({
                  placeholder: placeholder ? placeholder : "Search...",
                  leftIcon: "search",
                  fieldName: "search_text",
                  onChange: (() => {
                    const baseHandler = this.props.handleSearch
                      ? tab
                        ? (e) => this.props.handleSearch(tab, e)
                        : this.props.handleSearch
                      : this.handleSearch.bind(this);
                    if (!this.props.handlePressSearch) return baseHandler;
                    return (e) => {
                      baseHandler(e);
                      clearTimeout(this._searchTimer);
                      this._searchTimer = setTimeout(
                        () => this.props.handlePressSearch(),
                        400
                      );
                    };
                  })(),
                  iconRight: "search",
                  type: "search",
                  onKeyDown: this.props.handlePressSearch
                    ? (e) => {
                        if (e.key === "Enter") {
                          clearTimeout(this._searchTimer);
                          this.props.handlePressSearch();
                        }
                      }
                    : undefined,
                })}

              {this.props.addSearchButton && (
                <Button
                  className="btn-primary btn-sm"
                  icon="search"
                  onPress={() => {
                    clearTimeout(this._searchTimer);
                    this.props.handlePressSearch?.();
                  }}
                  isSubmitting={this.props.searching}
                />
              )}
              {this.props.moreFilters?.some(
                (el) => el.inputType === "input" || el.inputType === "selection"
              ) && (
                <div className="table-more-filters">
                  {this.props.moreFilters.map((el, i) => {
                    if (el.inputType === "input") {
                      return <React.Fragment key={i}>{this.renderInput({
                        placeholder: el.placeholder,
                        leftIcon: el.leftIcon,
                        fieldName: el.fieldName,
                        onChange: el.onChange,
                        iconRight: el.iconRight,
                        type: el.type,
                      })}</React.Fragment>;
                    }

                    if (el.inputType === "selection") {
                      return <React.Fragment key={i}>{this.renderSelection({
                        options: el.options,
                        placeholder: el.placeholder,
                        leftIcon: el.leftIcon,
                        fieldName: el.fieldName,
                        onChange: el.onChange,
                        iconRight: el.iconRight,
                        type: el.type,
                      })}</React.Fragment>;
                    }

                    return null;
                  })}
                </div>
              )}
              {this.props.moreFilters?.some((el) => el.inputType === "button") &&
                this.props.moreFilters.map((el, i) => {
                  if (el.inputType === "button") {
                    return <React.Fragment key={i}>{this.renderButton({
                      text: el.text,
                      onPress: el.onPress,
                      className: el.className,
                      data: this.props.data,
                    })}</React.Fragment>;
                  }
                  return null;
                })}
            </div>
            {/* <div className="w-md-100"></div> */}

            {filters &&
              filters.map((filter, f) => {
                if (filter.button_type === "dropdown") {
                  return (
                    <React.Fragment key={f}>
                      {filter.filterName === "donorCategory" ? (
                        <DonorCategoryFilter
                          filterName={filter.name}
                          handleApplyFilters={(loading, filters) =>
                            this.props.fetchData(loading, filters)
                          }
                        />
                      ) : filter.filterName === "center" ? (
                        <CentersFilter
                          filterName={filter.name}
                          handleApplyFilters={(loading, filters) =>
                            this.props.fetchData(loading, filters)
                          }
                        />
                      ) : filter.filterName === "centerSite" ? (
                        <CenterSitesFilter
                          filterName={filter.name}
                          handleApplyFilters={(loading, filters) =>
                            this.props.fetchData(loading, filters)
                          }
                        />
                      ) : filter.filterName === "hospital" ? (
                        <HospitalFilter
                          filterName={filter.name}
                          handleApplyFilters={(loading, filters) =>
                            this.props.fetchData(loading, filters)
                          }
                        />
                      ) : filter.filterName === "bloodGroup" ? (
                        <BloodGroupFilter
                          filterName={filter.name}
                          handleApplyFilters={(loading, filters) =>
                            this.props.fetchData(loading, filters)
                          }
                        />
                      ) : filter.filterName === "institution" ? (
                        <InstitutionFilter
                          filterName={filter.name}
                          handleApplyFilters={(loading, filters) =>
                            this.props.fetchData(loading, filters)
                          }
                        />
                      ) : filter.filterName === "department" ? (
                        <DepartmentFilter
                          filterName={filter.name}
                          handleApplyFilters={(loading, filters) =>
                            this.props.fetchData(loading, filters)
                          }
                        />
                      ) : filter.filterName === "hospital" ? (
                        <HospitalsFilter
                          filterName={filter.name}
                          handleApplyFilters={(loading, filters) =>
                            this.props.fetchData(loading, filters)
                          }
                        />
                      ) : filter.filterName === "date_range" ? (
                        <DateFilter
                          handleApplyFilters={(loading, filters) =>
                            this.props.fetchData(loading, filters)
                          }
                          startDate={filter.startDate}
                          endDate={filter.endDate}
                          filterName={filter.name}
                        />
                      ) : (
                        <DropdownButton
                          className="btn-transparent btn-bordered w-sm-100 btn-sm"
                          text={filter.title}
                          selected={filter.selected}
                          isSearchable={filter.isSearchable}
                          options={filter.options}
                          onSelectDropdownItem={filter.onSelectDropdownItem}
                          search_text={filter.search_text}
                          onChangeSearch={filter.onChangeSearch}
                          selected_item={filter.selected_item}
                          isLoading={filter.isLoading}
                          isMulti={filter.isMulti}
                          default_key={filter.default_key}
                          handleReset={filter.handleReset}
                          clickBehaviorId="dropdownMenuClickableInside"
                          autoCloseType="outside"
                          icon={filter.icon}
                        >
                          {filter?.options?.map((option, o) => {
                            return (
                              <li key={o}>
                                {option.isDownloadCsv ? (
                                  <CSVLink
                                    filename={option.filename + ".csv"}
                                    data={
                                      option && option.csvData
                                        ? option.csvData
                                        : []
                                    }
                                    asyncOnClick={true}
                                    // onClick={
                                    //   option.onPress ? option.onPress : null
                                    // }
                                    onClick={(event, done) => {
                                      option.onPress().then((res) => {
                                        done(false); // Don't Proceed
                                      });
                                    }}
                                    className="dropdown-item"
                                  >
                                    {option.name
                                      ? option.name
                                      : option.label
                                      ? option.label
                                      : ""}
                                  </CSVLink>
                                ) : (
                                  <Link
                                    onClick={() => option.onPress(option)}
                                    className="dropdown-item"
                                    to="#"
                                  >
                                    {option.name
                                      ? option.name
                                      : option.label
                                      ? option.label
                                      : ""}
                                  </Link>
                                )}
                              </li>
                            );
                          })}
                        </DropdownButton>
                      )}
                    </React.Fragment>
                  );
                } else {
                  return (
                    <Button
                      key={f}
                      selected={filter.selected}
                      className={`btn-transparent btn-bordered w-sm-100 btn-sm ${filter.className}`}
                      text={filter.title}
                      onPress={filter.onPress}
                      icon={filter.icon ? filter.icon : "filter_alt"}
                    />
                  );
                }
              })}
            {showAdd && (
              <Button
                className="btn-primary btn-sm"
                onPress={handleAddPressed}
                text={addButtonText}
                icon="add"
                isSubmitting={this.props.addButtonLoading}
              />
            )}
          </div>
        </div>
        {this.props.counts && (
          <div style={{ margin: "1.5rem 0" }}>{this.props.counts}</div>
        )}
        <div className="table-responsive">
          <table
            className={`table table-hover table-condensed ${
              bordered && "table-bordered"
            }`}
            style={this.props.style}
          >
            <thead style={this.props.style_header}>
              <tr>
                {headers &&
                  headers.map((item, i) => {
                    const isStickyActionColumn =
                      item.key === "action" || item.key === "multiple-actions";
                    return (
                      <th
                        key={i}
                        className={[isStickyActionColumn ? "table-sticky-action" : "", item.className || ""].filter(Boolean).join(" ")}
                      >
                        {item.title}
                        {item.sort && (
                          <button
                            className="sort-btn"
                            onClick={() => handleSort(item.key, tab)}
                          >
                            {(sortOrder === -1 || sortOrder === "desc") &&
                            sortColumn === item.key ? (
                              <i className="arrow_upward"></i>
                            ) : (
                              <i className="south"></i>
                            )}
                          </button>
                        )}
                      </th>
                    );
                  })}
              </tr>
            </thead>
            <tbody className={this.props.tableBodyClass}>
              {isLoading ? (
                <tr>
                  <td align="center" colSpan={headers.length}>
                    <Loading className="primary" />
                  </td>
                </tr>
              ) : !currentData || currentData.length === 0 ? (
                <tr>
                  <td colSpan={13} align="center" className="center">
                    No data found
                  </td>
                </tr>
              ) : (
                <TableData
                  data={currentData}
                  actions={actions}
                  rowPress={rowPress}
                  headers={headers}
                  collapsing={collapsing}
                >
                  {/* <div style={{ position: "absolute" }}>{collapsingData}</div> */}
                </TableData>
              )}
            </tbody>
          </table>
        </div>
        {totalPageCount !== 0 && totalPageCount && (
          <Pagination
            totalPageCount={totalPageCount}
            totalRecords={totalRecords}
            limit={limit}
            paginate={paginate}
            length={currentData ? currentData.length : 0}
            nextPage={nextPage}
            prevPage={prevPage}
            firstPage={firstPage}
            lastPage={lastPage}
            page={page}
            tab={tab}
            onLimitChange={handleLimitChange}
          />
        )}
      </div>
    );
  }
}

export default Table;
